/* Funnel listicle tracking. Lives here rather than inline because the section
   file has to stay under the 16,384 character GraphQL document cap. */
(function () {
  var root = document.querySelector('.fnl');
  if (!root) return;
  var name = root.getAttribute('data-pixel') || 'funnel';
  try { if (window.fbq) fbq('trackCustom', 'ViewContent', { content_name: name }); } catch (e) {}
  var qs = window.location.search || '';
  root.querySelectorAll('a[href^="/"]').forEach(function (a) {
    a.addEventListener('click', function () {
      try {
        if (window.fbq) fbq('trackCustom', 'fnl_cta_click',
          { content_name: name, dest: a.getAttribute('href') });
      } catch (e) {}
    });
    // carry the ad UTMs onto the destination so Shopify orders match back to ad_id
    var h = a.getAttribute('href');
    if (qs && h.indexOf('/products/') === 0 && h.indexOf('?') === -1) a.setAttribute('href', h + qs);
  });
})();
